import { HttpErrorResponse } from '@angular/common/http';

export const isConnectivityFailed = (err: HttpErrorResponse) => {
  return navigator.onLine && (err.status === 504 || (err.status === 0 && err.statusText === 'Unknown Error'));
};
